export const PHONE_STATUSES = {
  IDLE: 'IDLE',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  CALL_ESTABLISHED: 'CALL_ESTABLISHED',
  RECONNECTING: 'RECONNECTING'
} as const